import { OpenInNew } from "@mui/icons-material"
import { Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Locker } from "shared/locker"

/**
 * Read-only provenance behind the override: the driving Sstv2Migration record
 * and the head of `migrationNote` (which is where previous overrides log
 * themselves). Lives inside the Advanced section — the pair diagram already
 * answers "what is the state", so this only answers "how did it get there".
 */
export const SaLockerMigrationAncestry: FC<{ locker: Locker }> = ({ locker }) => {
  const { t } = useTranslation()

  if (!locker.sstv2MigrationThingId && !locker.migrationNote) return null

  return (
    <Stack direction="column" spacing={0.5}>
      {locker.sstv2MigrationThingId && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="caption" color="text.secondary">
            {t("lockerMigrationOverride.migrationRecord")}
          </Typography>
          <Link to="/sa/sstv2-migration" style={{ textDecoration: "none" }}>
            <Typography variant="caption" color="primary" fontFamily="monospace">
              {locker.sstv2MigrationThingId} <OpenInNew sx={{ fontSize: 11 }} />
            </Typography>
          </Link>
        </Stack>
      )}

      {locker.migrationNote && (
        <>
          <Typography variant="caption" color="text.secondary">
            {t("lockerMigrationOverride.noteHistory")}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              fontSize: "0.68rem",
              maxHeight: 96,
              overflowY: "auto",
              p: 1,
              borderRadius: 1,
              bgcolor: "grey.50",
            }}
          >
            {locker.migrationNote}
          </Typography>
        </>
      )}
    </Stack>
  )
}

export default SaLockerMigrationAncestry
